module.exports = __webpack_public_path__ + "img/Ortho.8dbe7efb.png";